import { ICasinoCollection, ISlotCollection } from 'constants/types';
import { createContext, useContext, useEffect, useState } from 'react';
import {
  emptySiteLayout,
  fetchSiteLayoutData,
  SiteLayoutData,
} from 'lib/site-layout';

const SiteLayoutContext = createContext<SiteLayoutData>(emptySiteLayout);

const hasLayoutData = (value?: SiteLayoutData | null) => {
  return Boolean(
    value?.casinoCollections?.length ||
      value?.slotCollections?.length ||
      value?.rtpiArticleLink
  );
};

export const SiteLayoutProvider = ({
  value,
  children,
}: {
  value?: SiteLayoutData | null;
  children: React.ReactNode;
}) => {
  const [layout, setLayout] = useState<SiteLayoutData>(
    value ?? emptySiteLayout
  );

  useEffect(() => {
    if (hasLayoutData(value)) {
      setLayout(value ?? emptySiteLayout);
      return;
    }

    let isMounted = true;

    fetchSiteLayoutData()
      .then((data) => {
        if (isMounted) {
          setLayout(data);
        }
      })
      .catch(() => {
        if (isMounted) {
          setLayout(emptySiteLayout);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [value]);

  return (
    <SiteLayoutContext.Provider value={layout}>
      {children}
    </SiteLayoutContext.Provider>
  );
};

export const useSiteLayout = () => useContext(SiteLayoutContext);

export type { ICasinoCollection, ISlotCollection };
